module.exports = __webpack_public_path__ + "static/media/car.5c1748ca.svg";